import { render } from "./WorkshopDetail.vue?vue&type=template&id=2c535d8d&scoped=true"
import script from "./WorkshopDetail.vue?vue&type=script&lang=js"
export * from "./WorkshopDetail.vue?vue&type=script&lang=js"

import "./WorkshopDetail.vue?vue&type=style&index=0&id=2c535d8d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c535d8d"]])

export default __exports__